/* VOLTRIK v2: site-wide behaviour (header, product page, reveals, cart). No libraries. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Header: shrink + solid after 100px */
  var hdr = $('[data-vk-hdr]');
  if (hdr) {
    var ticking = false;
    var upd = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 100); ticking = false; };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* Mobile menu */
  var menu = $('[data-vk-menu]');
  if (menu) {
    menu.addEventListener('toggle', function () { root.style.overflow = menu.open ? 'hidden' : ''; });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { menu.open = false; }); });
    $$('[data-vk-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { menu.open = false; }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.open) menu.open = false; });
  }

  /* Reveal on scroll (light wipes; product page + inner pages) */
  var rev = $$('.vk-wipe, .vk-rise');
  if (rev.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px' });
      rev.forEach(function (el) { io.observe(el); });
    } else rev.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Add to cart (any form with data-vk-atc-form) */
  function addToCart(form, btn) {
    var err = $('[data-vk-err]', form), label = btn && (btn.querySelector('span') || btn), prev = label ? label.textContent : '';
    if (err) err.textContent = '';
    if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding…'; }
    fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart. Please try again.'); return j; }); })
      .then(function () { window.location.href = cartRoot + 'cart'; })
      .catch(function (e) { if (err) err.textContent = e.message; else alert(e.message); if (btn) { btn.disabled = false; if (label) label.textContent = prev; } });
  }
  $$('[data-vk-atc-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); addToCart(f, e.submitter || $('[type=submit]', f)); });
  });

  /* Product page */
  var pdp = $('[data-vk-pdp]');
  if (pdp) {
    var form = $('[data-vk-buy-form]', pdp), atc = $('[data-vk-atc]', pdp), sticky = $('[data-vk-sticky]');
    var stickyBtn = sticky && $('[data-vk-sticky-atc]', sticky);
    var radios = $$('input[name=id]', form);
    var sel = function () { return $('input[name=id]:checked', form); };
    var setTxt = function (el, t) { if (!el) return; el.textContent = t || ''; el.hidden = !t; };
    var sync = function (push) {
      var r = sel(); if (!r) return;
      var ds = r.dataset, ok = ds.available === 'true';
      radios.forEach(function (x) { x.closest('.vk-opt').classList.toggle('is-on', x === r); });
      $('[data-vk-price]', pdp).textContent = ds.price;
      setTxt($('[data-vk-unit]', pdp), ds.unit);
      setTxt($('[data-vk-save]', pdp), ds.save);
      atc.disabled = !ok; $('span', atc).textContent = ok ? 'Add to cart' : 'Sold out';
      if (sticky) {
        $('[data-vk-sticky-n]', sticky).textContent = ds.title;
        $('[data-vk-sticky-p]', sticky).textContent = ds.price + (ds.save ? ' · ' + ds.save : '');
        stickyBtn.disabled = !ok; stickyBtn.textContent = ok ? 'Add to cart' : 'Sold out';
      }
      if (push && window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('pack', ds.pack); u.searchParams.delete('variant');
        history.replaceState(null, '', u.toString());
      }
    };
    /* ?pack=2 preselects a bundle */
    var want = new URLSearchParams(location.search).get('pack');
    if (want) radios.forEach(function (x) { if (x.dataset.pack === want) x.checked = true; });
    form.addEventListener('change', function (e) { if (e.target.name === 'id') sync(true); });
    sync(false);
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addToCart(form, stickyBtn); });
    if (sticky && 'IntersectionObserver' in window) {
      d.body.classList.add('vk-has-sticky');
      new IntersectionObserver(function (es) {
        var e = es[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
    /* Gallery */
    var slides = $$('[data-vk-slide]', pdp), thumbs = $$('[data-vk-thumb]', pdp);
    var show = function (i) {
      slides.forEach(function (s, k) {
        s.classList.toggle('is-on', k === i);
        var v = $('video', s); if (v && k !== i) v.pause();
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var main = $('.vk-gal__main', pdp), x0 = null, cur = function () { return slides.findIndex(function (s) { return s.classList.contains('is-on'); }); };
    if (main && slides.length > 1) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) show((cur() + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      });
    }
  }

  /* Cart page: update when quantity changes */
  $$('[data-vk-qty]').forEach(function (i) {
    i.addEventListener('change', function () { var b = $('[name=update]', i.form); if (i.form.requestSubmit && b) i.form.requestSubmit(b); else if (b) b.click(); });
  });
})();
